
// 公告类型
export const noticeTypeList = [
  { label: '采购公告', key: '采购公告', component: 'NoticeList', imgType: '1' },
  { label: '更正公告', key: '更正公告', component: 'NoticeList', imgType: '2' },
  { label: '结果公告', key: '结果公告', component: 'NoticeList', imgType: '1' },
  { label: '失败公告', key: '失败公告', component: 'NoticeList', imgType: '2' },
]

// 公示类型
export const publicityTypeList = [
  { label: '单一/唯一来源公示', key: '单一/唯一来源公示', component: 'NoticeList', imgType: '1' },
]

// 调查类型
export const intentionalSurveyTypeList = [
  { label: '市场调查公告', key: '市场调查公告', component: 'NoticeList', imgType: '1' },
  // { label: '意向公告', key: '意向公告', component: 'NoticeList', imgType: '2' },
  // { label: '调查公告', key: '调查公告', component: 'NoticeList', imgType: '1' },
  // { label: '调研公告', key: '调研公告', component: 'NoticeList', imgType: '2' },
  { label: '市场调查更正公告', key: '市场调查更正公告', component: 'NoticeList', imgType: '1' },
  // { label: '调研结果公告', key: '调研结果公告', component: 'NoticeList', imgType: '2' },
]

// 零星采购类型
export const lxSelfBiddingNoticeTypeList = [
  { label: '零星采购公告', key: '零星采购公告', component: 'NoticeList', imgType: '1' },
  { label: '零星变更公告', key: '零星变更公告', component: 'NoticeList', imgType: '1' },
  { label: '零星结果公告', key: '零星结果公告', component: 'NoticeList', imgType: '1' },
  { label: '零星失败公告', key: '零星失败公告', component: 'NoticeList', imgType: '1' },
]

export function getFilter(noticeType) {
  const siteId = window.urlConfig?.web?.siteId
  const noticeTypeChannelId = window.urlConfig?.web?.noticeTypeChannelId
  const researchNoticeTypeChannelId = window.urlConfig?.web?.researchNoticeTypeChannelId
  // const lxSelfBiddingNoticeChannelId = window.urlConfig?.web?.lxSelfBiddingNoticeChannelId
  let filter = `siteId == ${siteId} && checked == true`
  if (noticeType == '所有公告' || noticeType == '市场调查公告') {
    const noticeChannelIds = noticeType == '所有公告' ? noticeTypeChannelId : researchNoticeTypeChannelId
    // const channelIds = Object.values(noticeTypeChannelId).join(',')
    // filter += ` && channelId in "${channelIds}"`
    filter += ` && (`
    const channelIds = Object.values(noticeChannelIds)
    channelIds.forEach(item => {
      filter += ` channelId == ${item} ||`
    })
    filter = filter.slice(0, filter.length - 3) + ' )'
  } else {
    filter += ` && channelId == ${noticeTypeChannelId[noticeType]}`
  }
  return filter
}

export function getFilter1(noticeType) {
  const siteId = window.urlConfig?.web?.siteId
  const otherTypeChannelId = window.urlConfig?.web?.otherTypeChannelId
  let filter = `siteId == ${siteId} && checked == true`
  const channelId = otherTypeChannelId[noticeType]
  if (Array.isArray(channelId)) {
    // const id = channelId.join(',')
    // filter += ` && channelId in "${id}"`
    filter += ` && (`
    channelId.forEach(item => {
      filter += ` channelId == ${item} ||`
    })
    filter = filter.slice(0, filter.length - 3) + ' )'
  } else if(typeof channelId === 'number') {
    filter += ` && channelId == ${channelId}`
  }
  return filter
}

export default {
  noticeTypeList,
  publicityTypeList,
  intentionalSurveyTypeList,
  lxSelfBiddingNoticeTypeList,
  getFilter
}
